/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AlertaResponse,
  AlertasAdminControllerListarOcorrenciasParams,
  AlertasAdminControllerListarParams,
  AlterarStatusDoAlertaDto,
  AtualizarDestinatarioDto,
  CriarDestinatarioDto,
  DestinatarioDeAlertaResponse,
  ErroResponse,
  ListaDeDestinatariosResponse,
  PaginaDeAlertasResponse,
  PaginaDeOcorrenciasResponse,
  ResumoDeAlertasResponse
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getAlertasAdminControllerListarUrl = (params?: AlertasAdminControllerListarParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/admin/alertas?${stringifiedParams}` : `/v1/admin/alertas`
}

/**
 * @summary Lista os alertas de erro, paginados e filtráveis
 */
export const alertasAdminControllerListar = async (params?: AlertasAdminControllerListarParams, options?: Parameters<typeof httpClient>[1]): Promise<PaginaDeAlertasResponse> => {

  return httpClient<PaginaDeAlertasResponse>(getAlertasAdminControllerListarUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAlertasAdminControllerListarQueryKey = (params?: AlertasAdminControllerListarParams,) => {
    return [
    `/v1/admin/alertas`, ...(params ? [params] : [])
    ] as const;
    }


export const getAlertasAdminControllerListarQueryOptions = <TData = Awaited<ReturnType<typeof alertasAdminControllerListar>>, TError = ErroResponse>(params?: AlertasAdminControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof alertasAdminControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAlertasAdminControllerListarQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof alertasAdminControllerListar>>> = ({ signal }) => alertasAdminControllerListar(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof alertasAdminControllerListar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AlertasAdminControllerListarQueryResult = NonNullable<Awaited<ReturnType<typeof alertasAdminControllerListar>>>
export type AlertasAdminControllerListarQueryError = ErroResponse


export function useAlertasAdminControllerListar<TData = Awaited<ReturnType<typeof alertasAdminControllerListar>>, TError = ErroResponse>(
 params: undefined |  AlertasAdminControllerListarParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof alertasAdminControllerListar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof alertasAdminControllerListar>>,
          TError,
          Awaited<ReturnType<typeof alertasAdminControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAlertasAdminControllerListar<TData = Awaited<ReturnType<typeof alertasAdminControllerListar>>, TError = ErroResponse>(
 params?: AlertasAdminControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof alertasAdminControllerListar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof alertasAdminControllerListar>>,
          TError,
          Awaited<ReturnType<typeof alertasAdminControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAlertasAdminControllerListar<TData = Awaited<ReturnType<typeof alertasAdminControllerListar>>, TError = ErroResponse>(
 params?: AlertasAdminControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof alertasAdminControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os alertas de erro, paginados e filtráveis
 */

export function useAlertasAdminControllerListar<TData = Awaited<ReturnType<typeof alertasAdminControllerListar>>, TError = ErroResponse>(
 params?: AlertasAdminControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof alertasAdminControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAlertasAdminControllerListarQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAlertasAdminControllerResumoUrl = () => {




  return `/v1/admin/alertas/resumo`
}

/**
 * @summary Quantos alertas estão abertos por severidade — o selo do menu
 */
export const alertasAdminControllerResumo = async ( options?: Parameters<typeof httpClient>[1]): Promise<ResumoDeAlertasResponse> => {

  return httpClient<ResumoDeAlertasResponse>(getAlertasAdminControllerResumoUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAlertasAdminControllerResumoQueryKey = () => {
    return [
    `/v1/admin/alertas/resumo`
    ] as const;
    }


export const getAlertasAdminControllerResumoQueryOptions = <TData = Awaited<ReturnType<typeof alertasAdminControllerResumo>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof alertasAdminControllerResumo>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAlertasAdminControllerResumoQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof alertasAdminControllerResumo>>> = ({ signal }) => alertasAdminControllerResumo({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof alertasAdminControllerResumo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AlertasAdminControllerResumoQueryResult = NonNullable<Awaited<ReturnType<typeof alertasAdminControllerResumo>>>
export type AlertasAdminControllerResumoQueryError = unknown


export function useAlertasAdminControllerResumo<TData = Awaited<ReturnType<typeof alertasAdminControllerResumo>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof alertasAdminControllerResumo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof alertasAdminControllerResumo>>,
          TError,
          Awaited<ReturnType<typeof alertasAdminControllerResumo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAlertasAdminControllerResumo<TData = Awaited<ReturnType<typeof alertasAdminControllerResumo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof alertasAdminControllerResumo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof alertasAdminControllerResumo>>,
          TError,
          Awaited<ReturnType<typeof alertasAdminControllerResumo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAlertasAdminControllerResumo<TData = Awaited<ReturnType<typeof alertasAdminControllerResumo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof alertasAdminControllerResumo>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Quantos alertas estão abertos por severidade — o selo do menu
 */

export function useAlertasAdminControllerResumo<TData = Awaited<ReturnType<typeof alertasAdminControllerResumo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof alertasAdminControllerResumo>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAlertasAdminControllerResumoQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAlertasAdminControllerListarDestinatariosUrl = () => {




  return `/v1/admin/alertas/destinatarios`
}

/**
 * @summary Lista quem recebe o e-mail de alerta crítico
 */
export const alertasAdminControllerListarDestinatarios = async ( options?: Parameters<typeof httpClient>[1]): Promise<ListaDeDestinatariosResponse> => {

  return httpClient<ListaDeDestinatariosResponse>(getAlertasAdminControllerListarDestinatariosUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAlertasAdminControllerListarDestinatariosQueryKey = () => {
    return [
    `/v1/admin/alertas/destinatarios`
    ] as const;
    }


export const getAlertasAdminControllerListarDestinatariosQueryOptions = <TData = Awaited<ReturnType<typeof alertasAdminControllerListarDestinatarios>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof alertasAdminControllerListarDestinatarios>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAlertasAdminControllerListarDestinatariosQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof alertasAdminControllerListarDestinatarios>>> = ({ signal }) => alertasAdminControllerListarDestinatarios({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof alertasAdminControllerListarDestinatarios>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AlertasAdminControllerListarDestinatariosQueryResult = NonNullable<Awaited<ReturnType<typeof alertasAdminControllerListarDestinatarios>>>
export type AlertasAdminControllerListarDestinatariosQueryError = unknown


export function useAlertasAdminControllerListarDestinatarios<TData = Awaited<ReturnType<typeof alertasAdminControllerListarDestinatarios>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof alertasAdminControllerListarDestinatarios>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof alertasAdminControllerListarDestinatarios>>,
          TError,
          Awaited<ReturnType<typeof alertasAdminControllerListarDestinatarios>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAlertasAdminControllerListarDestinatarios<TData = Awaited<ReturnType<typeof alertasAdminControllerListarDestinatarios>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof alertasAdminControllerListarDestinatarios>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof alertasAdminControllerListarDestinatarios>>,
          TError,
          Awaited<ReturnType<typeof alertasAdminControllerListarDestinatarios>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAlertasAdminControllerListarDestinatarios<TData = Awaited<ReturnType<typeof alertasAdminControllerListarDestinatarios>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof alertasAdminControllerListarDestinatarios>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista quem recebe o e-mail de alerta crítico
 */

export function useAlertasAdminControllerListarDestinatarios<TData = Awaited<ReturnType<typeof alertasAdminControllerListarDestinatarios>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof alertasAdminControllerListarDestinatarios>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAlertasAdminControllerListarDestinatariosQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAlertasAdminControllerCriarDestinatarioUrl = () => {




  return `/v1/admin/alertas/destinatarios`
}

/**
 * @summary Cadastra um e-mail para receber os alertas críticos
 */
export const alertasAdminControllerCriarDestinatario = async (criarDestinatarioDto: CriarDestinatarioDto, options?: Parameters<typeof httpClient>[1]): Promise<DestinatarioDeAlertaResponse> => {

  return httpClient<DestinatarioDeAlertaResponse>(getAlertasAdminControllerCriarDestinatarioUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(criarDestinatarioDto)
  }
);}





export const getAlertasAdminControllerCriarDestinatarioMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof alertasAdminControllerCriarDestinatario>>, TError,{data: CriarDestinatarioDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof alertasAdminControllerCriarDestinatario>>, TError,{data: CriarDestinatarioDto}, TContext> => {

const mutationKey = ['alertasAdminControllerCriarDestinatario'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof alertasAdminControllerCriarDestinatario>>, {data: CriarDestinatarioDto}> = (props) => {
          const {data} = props ?? {};

          return  alertasAdminControllerCriarDestinatario(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AlertasAdminControllerCriarDestinatarioMutationResult = NonNullable<Awaited<ReturnType<typeof alertasAdminControllerCriarDestinatario>>>
    export type AlertasAdminControllerCriarDestinatarioMutationBody = CriarDestinatarioDto
    export type AlertasAdminControllerCriarDestinatarioMutationError = ErroResponse

    /**
 * @summary Cadastra um e-mail para receber os alertas críticos
 */
export const useAlertasAdminControllerCriarDestinatario = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof alertasAdminControllerCriarDestinatario>>, TError,{data: CriarDestinatarioDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof alertasAdminControllerCriarDestinatario>>,
        TError,
        {data: CriarDestinatarioDto},
        TContext
      > => {
      return useMutation(getAlertasAdminControllerCriarDestinatarioMutationOptions(options), queryClient);
    }
    export const getAlertasAdminControllerAtualizarDestinatarioUrl = (id: string,) => {




  return `/v1/admin/alertas/destinatarios/${id}`
}

/**
 * @summary Edita, ativa ou desativa um destinatário
 */
export const alertasAdminControllerAtualizarDestinatario = async (id: string,
    atualizarDestinatarioDto: AtualizarDestinatarioDto, options?: Parameters<typeof httpClient>[1]): Promise<DestinatarioDeAlertaResponse> => {

  return httpClient<DestinatarioDeAlertaResponse>(getAlertasAdminControllerAtualizarDestinatarioUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(atualizarDestinatarioDto)
  }
);}





export const getAlertasAdminControllerAtualizarDestinatarioMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof alertasAdminControllerAtualizarDestinatario>>, TError,{id: string;data: AtualizarDestinatarioDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof alertasAdminControllerAtualizarDestinatario>>, TError,{id: string;data: AtualizarDestinatarioDto}, TContext> => {

const mutationKey = ['alertasAdminControllerAtualizarDestinatario'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof alertasAdminControllerAtualizarDestinatario>>, {id: string;data: AtualizarDestinatarioDto}> = (props) => {
          const {id,data} = props ?? {};

          return  alertasAdminControllerAtualizarDestinatario(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AlertasAdminControllerAtualizarDestinatarioMutationResult = NonNullable<Awaited<ReturnType<typeof alertasAdminControllerAtualizarDestinatario>>>
    export type AlertasAdminControllerAtualizarDestinatarioMutationBody = AtualizarDestinatarioDto
    export type AlertasAdminControllerAtualizarDestinatarioMutationError = ErroResponse

    /**
 * @summary Edita, ativa ou desativa um destinatário
 */
export const useAlertasAdminControllerAtualizarDestinatario = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof alertasAdminControllerAtualizarDestinatario>>, TError,{id: string;data: AtualizarDestinatarioDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof alertasAdminControllerAtualizarDestinatario>>,
        TError,
        {id: string;data: AtualizarDestinatarioDto},
        TContext
      > => {
      return useMutation(getAlertasAdminControllerAtualizarDestinatarioMutationOptions(options), queryClient);
    }
    export const getAlertasAdminControllerExcluirDestinatarioUrl = (id: string,) => {




  return `/v1/admin/alertas/destinatarios/${id}`
}

/**
 * @summary Remove um destinatário
 */
export const alertasAdminControllerExcluirDestinatario = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getAlertasAdminControllerExcluirDestinatarioUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAlertasAdminControllerExcluirDestinatarioMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof alertasAdminControllerExcluirDestinatario>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof alertasAdminControllerExcluirDestinatario>>, TError,{id: string}, TContext> => {

const mutationKey = ['alertasAdminControllerExcluirDestinatario'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof alertasAdminControllerExcluirDestinatario>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  alertasAdminControllerExcluirDestinatario(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AlertasAdminControllerExcluirDestinatarioMutationResult = NonNullable<Awaited<ReturnType<typeof alertasAdminControllerExcluirDestinatario>>>

    export type AlertasAdminControllerExcluirDestinatarioMutationError = ErroResponse

    /**
 * @summary Remove um destinatário
 */
export const useAlertasAdminControllerExcluirDestinatario = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof alertasAdminControllerExcluirDestinatario>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof alertasAdminControllerExcluirDestinatario>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getAlertasAdminControllerExcluirDestinatarioMutationOptions(options), queryClient);
    }
    export const getAlertasAdminControllerEnviarTesteUrl = (id: string,) => {




  return `/v1/admin/alertas/destinatarios/${id}/teste`
}

/**
 * @summary Manda um e-mail de teste para o destinatário
 */
export const alertasAdminControllerEnviarTeste = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getAlertasAdminControllerEnviarTesteUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAlertasAdminControllerEnviarTesteMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof alertasAdminControllerEnviarTeste>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof alertasAdminControllerEnviarTeste>>, TError,{id: string}, TContext> => {

const mutationKey = ['alertasAdminControllerEnviarTeste'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof alertasAdminControllerEnviarTeste>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  alertasAdminControllerEnviarTeste(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AlertasAdminControllerEnviarTesteMutationResult = NonNullable<Awaited<ReturnType<typeof alertasAdminControllerEnviarTeste>>>

    export type AlertasAdminControllerEnviarTesteMutationError = ErroResponse

    /**
 * @summary Manda um e-mail de teste para o destinatário
 */
export const useAlertasAdminControllerEnviarTeste = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof alertasAdminControllerEnviarTeste>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof alertasAdminControllerEnviarTeste>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getAlertasAdminControllerEnviarTesteMutationOptions(options), queryClient);
    }
    export const getAlertasAdminControllerObterUrl = (id: string,) => {




  return `/v1/admin/alertas/${id}`
}

/**
 * @summary Detalha um alerta
 */
export const alertasAdminControllerObter = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<AlertaResponse> => {

  return httpClient<AlertaResponse>(getAlertasAdminControllerObterUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAlertasAdminControllerObterQueryKey = (id: string,) => {
    return [
    `/v1/admin/alertas/${id}`
    ] as const;
    }


export const getAlertasAdminControllerObterQueryOptions = <TData = Awaited<ReturnType<typeof alertasAdminControllerObter>>, TError = ErroResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof alertasAdminControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAlertasAdminControllerObterQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof alertasAdminControllerObter>>> = ({ signal }) => alertasAdminControllerObter(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof alertasAdminControllerObter>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AlertasAdminControllerObterQueryResult = NonNullable<Awaited<ReturnType<typeof alertasAdminControllerObter>>>
export type AlertasAdminControllerObterQueryError = ErroResponse


export function useAlertasAdminControllerObter<TData = Awaited<ReturnType<typeof alertasAdminControllerObter>>, TError = ErroResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof alertasAdminControllerObter>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof alertasAdminControllerObter>>,
          TError,
          Awaited<ReturnType<typeof alertasAdminControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAlertasAdminControllerObter<TData = Awaited<ReturnType<typeof alertasAdminControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof alertasAdminControllerObter>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof alertasAdminControllerObter>>,
          TError,
          Awaited<ReturnType<typeof alertasAdminControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAlertasAdminControllerObter<TData = Awaited<ReturnType<typeof alertasAdminControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof alertasAdminControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Detalha um alerta
 */

export function useAlertasAdminControllerObter<TData = Awaited<ReturnType<typeof alertasAdminControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof alertasAdminControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAlertasAdminControllerObterQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAlertasAdminControllerListarOcorrenciasUrl = (id: string,
    params?: AlertasAdminControllerListarOcorrenciasParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/admin/alertas/${id}/ocorrencias?${stringifiedParams}` : `/v1/admin/alertas/${id}/ocorrencias`
}

/**
 * @summary Últimas ocorrências do alerta, com a requisição enviada e a resposta de erro (sanitizadas)
 */
export const alertasAdminControllerListarOcorrencias = async (id: string,
    params?: AlertasAdminControllerListarOcorrenciasParams, options?: Parameters<typeof httpClient>[1]): Promise<PaginaDeOcorrenciasResponse> => {

  return httpClient<PaginaDeOcorrenciasResponse>(getAlertasAdminControllerListarOcorrenciasUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAlertasAdminControllerListarOcorrenciasQueryKey = (id: string,
    params?: AlertasAdminControllerListarOcorrenciasParams,) => {
    return [
    `/v1/admin/alertas/${id}/ocorrencias`, ...(params ? [params] : [])
    ] as const;
    }


export const getAlertasAdminControllerListarOcorrenciasQueryOptions = <TData = Awaited<ReturnType<typeof alertasAdminControllerListarOcorrencias>>, TError = ErroResponse>(id: string,
    params?: AlertasAdminControllerListarOcorrenciasParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof alertasAdminControllerListarOcorrencias>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAlertasAdminControllerListarOcorrenciasQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof alertasAdminControllerListarOcorrencias>>> = ({ signal }) => alertasAdminControllerListarOcorrencias(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof alertasAdminControllerListarOcorrencias>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AlertasAdminControllerListarOcorrenciasQueryResult = NonNullable<Awaited<ReturnType<typeof alertasAdminControllerListarOcorrencias>>>
export type AlertasAdminControllerListarOcorrenciasQueryError = ErroResponse


export function useAlertasAdminControllerListarOcorrencias<TData = Awaited<ReturnType<typeof alertasAdminControllerListarOcorrencias>>, TError = ErroResponse>(
 id: string,
    params: undefined |  AlertasAdminControllerListarOcorrenciasParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof alertasAdminControllerListarOcorrencias>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof alertasAdminControllerListarOcorrencias>>,
          TError,
          Awaited<ReturnType<typeof alertasAdminControllerListarOcorrencias>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAlertasAdminControllerListarOcorrencias<TData = Awaited<ReturnType<typeof alertasAdminControllerListarOcorrencias>>, TError = ErroResponse>(
 id: string,
    params?: AlertasAdminControllerListarOcorrenciasParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof alertasAdminControllerListarOcorrencias>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof alertasAdminControllerListarOcorrencias>>,
          TError,
          Awaited<ReturnType<typeof alertasAdminControllerListarOcorrencias>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAlertasAdminControllerListarOcorrencias<TData = Awaited<ReturnType<typeof alertasAdminControllerListarOcorrencias>>, TError = ErroResponse>(
 id: string,
    params?: AlertasAdminControllerListarOcorrenciasParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof alertasAdminControllerListarOcorrencias>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Últimas ocorrências do alerta, com a requisição enviada e a resposta de erro (sanitizadas)
 */

export function useAlertasAdminControllerListarOcorrencias<TData = Awaited<ReturnType<typeof alertasAdminControllerListarOcorrencias>>, TError = ErroResponse>(
 id: string,
    params?: AlertasAdminControllerListarOcorrenciasParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof alertasAdminControllerListarOcorrencias>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAlertasAdminControllerListarOcorrenciasQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAlertasAdminControllerAlterarStatusUrl = (id: string,) => {




  return `/v1/admin/alertas/${id}/status`
}

/**
 * @summary Resolve, silencia ou reabre um alerta
 */
export const alertasAdminControllerAlterarStatus = async (id: string,
    alterarStatusDoAlertaDto: AlterarStatusDoAlertaDto, options?: Parameters<typeof httpClient>[1]): Promise<AlertaResponse> => {

  return httpClient<AlertaResponse>(getAlertasAdminControllerAlterarStatusUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(alterarStatusDoAlertaDto)
  }
);}





export const getAlertasAdminControllerAlterarStatusMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof alertasAdminControllerAlterarStatus>>, TError,{id: string;data: AlterarStatusDoAlertaDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof alertasAdminControllerAlterarStatus>>, TError,{id: string;data: AlterarStatusDoAlertaDto}, TContext> => {

const mutationKey = ['alertasAdminControllerAlterarStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof alertasAdminControllerAlterarStatus>>, {id: string;data: AlterarStatusDoAlertaDto}> = (props) => {
          const {id,data} = props ?? {};

          return  alertasAdminControllerAlterarStatus(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AlertasAdminControllerAlterarStatusMutationResult = NonNullable<Awaited<ReturnType<typeof alertasAdminControllerAlterarStatus>>>
    export type AlertasAdminControllerAlterarStatusMutationBody = AlterarStatusDoAlertaDto
    export type AlertasAdminControllerAlterarStatusMutationError = ErroResponse

    /**
 * @summary Resolve, silencia ou reabre um alerta
 */
export const useAlertasAdminControllerAlterarStatus = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof alertasAdminControllerAlterarStatus>>, TError,{id: string;data: AlterarStatusDoAlertaDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof alertasAdminControllerAlterarStatus>>,
        TError,
        {id: string;data: AlterarStatusDoAlertaDto},
        TContext
      > => {
      return useMutation(getAlertasAdminControllerAlterarStatusMutationOptions(options), queryClient);
    }
